import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response";

export const useDeleteRosterPlayer = () => {
  const { sport, organizationId, seasonId, fixtureId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (personId: string) => {
      const url = fixtureId
        ? `${sport}/o/${organizationId}/fixtures/${fixtureId}/persons/${personId}/roster`
        : `${sport}/o/${organizationId}/seasons/${seasonId}/persons/${personId}/roster`;

      return await request(url, {
        method: "DELETE",
      });
    },
    onSuccess: async (response) => {
      if (!response?.data?.[0]?.success) {
        return;
      }

      if (fixtureId) {
        await queryClient.invalidateQueries({
          queryKey: ["fixtureRoster", sport, organizationId, seasonId],
        });
        return;
      }

      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["seasonRoster", sport, organizationId, seasonId],
        }),
        queryClient.invalidateQueries({
          queryKey: ["seasonRosterShort", sport, organizationId, seasonId],
        }),
      ]);
    },
  });
};
